import { SUPPORTED_FAVICON_FORMATS } from '../business-logic/features/favicon';
import { SUPPORTED_FONT_FORMATS } from '../business-logic/features/fonts/constants';
import { SUPPORTED_VOICE_NOTE_FORMATS } from '../business-logic/features/voiceNotes';
import { SUPPORTED_WALLET_CONFIG_BACKGROUND_FORMATS } from '../business-logic/features/wallet';
import { SupportedFormatType } from '../types/api/asset.type';
import { AssetPath } from '../types/api/asset.type';
import { LEAD_ATTACHMENT_SUPPORTED_FORMATS, LEAD_SIGNATURE_SUPPORTED_FORMATS } from './entities';

export const ASSET_PATHS = {
  Font: 'font',
  VoiceNote: 'voice-note',
  LeadAttachment: 'lead-attachment',
  LeadSignature: 'lead-signature',
  Favicon: 'favicon',
  WalletConfigBackground: 'wallet-config-background',
} as const;

export const SUPPORTED_FORMATS: Record<AssetPath, SupportedFormatType[]> = {
  [ASSET_PATHS.Font]: SUPPORTED_FONT_FORMATS.map(format => ({
    mime: format.mime,
    ext: format.ext,
  })),
  [ASSET_PATHS.LeadAttachment]: LEAD_ATTACHMENT_SUPPORTED_FORMATS.map(format => ({
    mime: format.mime,
    ext: format.ext,
  })),
  [ASSET_PATHS.VoiceNote]: SUPPORTED_VOICE_NOTE_FORMATS.map(format => ({
    mime: format.mime,
    ext: format.ext,
  })),
  [ASSET_PATHS.Favicon]: SUPPORTED_FAVICON_FORMATS.map(format => ({
    mime: format.mime,
    ext: format.ext,
  })),
  [ASSET_PATHS.WalletConfigBackground]: SUPPORTED_WALLET_CONFIG_BACKGROUND_FORMATS.map(format => ({
    mime: format.mime,
    ext: format.ext,
  })),
  [ASSET_PATHS.LeadSignature]: LEAD_SIGNATURE_SUPPORTED_FORMATS.map(format => ({
    mime: format.mime,
    ext: format.ext,
  })),
};
